/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { ItemVariantGroupResult } from '../../models/item-variant-group-result';

export interface ItemVariantGroupsItemVariantGroupIdGet$Params {
  'Active-Tenant-Identifier': string;
  itemVariantGroupId: string;
}

export function itemVariantGroupsItemVariantGroupIdGet(http: HttpClient, rootUrl: string, params: ItemVariantGroupsItemVariantGroupIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & ItemVariantGroupResult>> {
  const rb = new RequestBuilder(rootUrl, itemVariantGroupsItemVariantGroupIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('itemVariantGroupId', params.itemVariantGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & ItemVariantGroupResult>;
    })
  );
}

itemVariantGroupsItemVariantGroupIdGet.PATH = '/item-variant-groups/{itemVariantGroupId}';
